import React, { useEffect, useState } from "react";
import { Search, Table,Button, IconDownload,Select } from "@veneer/core";
import XLSX from 'xlsx';
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import { numberFormatComma } from "../../../common/js/utils/numberFormat";
import moment from "moment";
import { Trans } from "react-i18next";
import { withTranslation } from "react-i18next";
import { authenticationService } from "../../../services/context/AuthService";

const Orders = (props) => {
  const configCompensation = [
    {
      id: "idOrderFormatted",
      label: <Trans i18nKey="orderNum" />,
    },
    {
      id: "dateFormatted",
      label: <Trans i18nKey="date" />,
    },
    {
      id: "customerName",
      label: <Trans i18nKey="channel" />,
    },
    {
      id: "endUserName",
      label: <Trans i18nKey="Client" />,
    },
    { id: "status", label: <Trans i18nKey="Status" /> },
    { id: "statusDateFormatted", label: <Trans i18nKey="statusdate" /> },
    {
      id: "compensationClientFormatted",
      label: <Trans i18nKey="balancereport.compclient" />,      
    },
    // {
    //   id: "compensationChannelFormatted",
    //   label: <Trans i18nKey="compchannel" />,
    // },
    { id: "subRegion", label: <Trans i18nKey="Subregion" /> },
    { id: "comments", label: <Trans i18nKey="comments" /> },
  ];
  const connectApi = new ConnectAPI();
  const [config, setConfig] = useState(configCompensation);
  const [order, setOrder] = useState(config.map((c) => c.id));
  const [orderBy, setOrderBy] = useState("idOrderFormatted");
  const [orderType, setOrderType] = useState("descending");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [endUserName, setEndUserName] = useState("");
  const [idOrder, setIdOrder] = useState("");
  const [subRegion, setSubRegion] = useState("");
  const [commentfilter, setcommentfilter]=useState("");
  const pageSize = 100;
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const items = [
    { value: 'Under Approval', label: 'Under Approval' },
    { value: 'Shipped', label: 'Shipped' },
    { value: 'Approved', label: 'Approved' },
    { value: 'Denied', label: 'Denied' }
  ];
  const [options, setOptions] = useState(items);
  const [statusfilter, setstatusfilter] = useState([]);
  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
        if (ur==window.location.pathname){
            validate=true;
        }
    });
    if (validate==false){
        const { history } = props;
        history.push({
            pathname: '/' 
        });
    }
    //end validate
    const handleSelectOrder = (index) => (event) => {
      event.preventDefault();
      const { history } = props;
      history.push({
        pathname: "/cpp/report/statement/order/" + index.idOrder,
        data: index,
      });
    };
    const fetchData = async () => {
      setIsLoading(true);

      connectApi
        .get("api/Channels/Orders/", "", dataResponseLoad)
        .catch((error) => {
          if(error.response.status==510){
            authenticationService.logout();
          }else{
            setIsLoading(false);
            console.log(error);
            Swal.fire(
              "Error " + error.response?.status,
              error.response?.data,
              "error"
            );
          }
          
        });
    };

    const dataResponseLoad = (status, data) => {
      data.map((item) => {
        // item.compensationChannelFormatted =
        //   item.compensationChannel == null
        //     ? "-"
        //     : numberFormatComma(item.compensationChannel);
        item.compensationClientFormatted = (item.idCustomer==item.idEndUser)?(numberFormatComma(item.compensationChannel)):(item.compensationClient == null? "-": numberFormatComma(item.compensationClient)) ;
        item.idOrderFormatted = (
          <a href={item.idOrder} onClick={handleSelectOrder(item)}>
            {item.idOrder}
          </a>
        );
        item.comments=item.comments?item.comments:"";
        item.name=item.endUserName;
        item.dateFormatted = moment(item.date).format("DD/MMM/YYYY");
        item.statusDateFormatted =
          item.statusDate === null
            ? ""
            : moment(item.statusDate).format("DD/MMM/YYYY");
      });
      setTableData(data);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const handlePageChange = (page) => setCurrentPage(page);

  const handleOnColumnReorder = (newOrder) => {
    setOrder(newOrder);
  };
  
  /*const filteredData = filterSort(
    tableData,
    { customerName, endUserName, subRegion, idOrder },
    orderBy,
    orderType
  );*/
  const datatotal=filter(tableData,
    {
      customerName:customerName,
      name:endUserName, 
      subRegion:subRegion, 
      idOrder:idOrder,
      comments:commentfilter,
      status:statusfilter
    }
  );
  const filteredData=sort(datatotal, orderBy, orderType)

  function filter(array, filters) {
    let arrayFiltered = array;
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter = typeof filterValue === 'object' ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();
          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });
    return arrayFiltered;
  }
  function sort(array, orderBy, orderType) { 
    return array.sort((a, b) => {
      const value = (orderType === 'descending')
        ? descendingComparator(a, b, orderBy)
        : -descendingComparator(a, b, orderBy);
  
      return value;
    });
  }
  /*function filterSort(array, filters, orderBy, orderType) {
    let arrayFiltered = array;
    // filter
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      console.log(filterValue);
      console.log("salida-----");
      const filter =
        typeof filterValue === "object" ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();

          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });

    // sort
    return arrayFiltered.sort((a, b) => {
      const value =
        orderType === "descending"
          ? descendingComparator(a, b, orderBy)
          : -descendingComparator(a, b, orderBy);

      return value;
    });


  }*/

  function descendingComparator(a, b, orderBy) {
    let aSort =
      typeof a[orderBy] === "object"
        ? typeof a[orderBy] === typeof (<a />)
          ? a[orderBy].props.href.toString().toUpperCase()
          : a[orderBy].props.label.toString().toUpperCase()
        : a[orderBy].toString().toUpperCase();
    let bSort =
      typeof b[orderBy] === "object"
        ? typeof b[orderBy] === typeof (<a />)
          ? b[orderBy].props.href.toString().toUpperCase()
          : b[orderBy].props.label.toString().toUpperCase()
        : b[orderBy].toString().toUpperCase();
    if (orderBy.includes("Formatted")) {
      const orderByFormatted = orderBy.replace("Formatted", "");
      aSort = a[orderByFormatted];
      bSort = b[orderByFormatted];
    }
    if (bSort < aSort) {
      return -1;
    }
    if (bSort > aSort) {
      return 1;
    }
    return 0;
  }

  let pagedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  ).map( x => {
      x.endUserName = (
          <a href={"/cpp/report/" + x.idEndUser}>
              {x.endUserName}
          </a>
      );
      return x;
  });

  const handleSort = (_, { id, type }) => {
    setOrderBy(id);
    setOrderType(type);
  };
  const redirectAction = () => {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let url='/cpp/report/statement/detail/'+currentUser.idEndUser+'/'+currentUser.idCustomer;
    const { history } = props;
    history.push({
        pathname: url
    });

  };
  const onChangestatus = (selectedOption) => setstatusfilter([selectedOption.value]);
  const onClearstatus = () => setstatusfilter([]);
  return (
    <div>
      <div>
        <br />
        <div
          style={{
            backgroundColor: "#f2f2f2",
            padding: "0.5%",
          }}
        >
          {(JSON.parse(localStorage.getItem("currentUser")).idRole==11 || JSON.parse(localStorage.getItem("currentUser")).idRole==12)?(
            <Button onClick={redirectAction}>
              Statement
            </Button>
          ):("")}
          
          <Table
            showFilters
            columnReorder
            columns={[
              {
                id: "idOrderFormatted",
                label: <Trans i18nKey="orderNum" />,
                filter: (
                  <Search
                    name="order-search"
                    value={idOrder}
                    onChange={setIdOrder}
                  />
                ),
              },
              {
                id: "dateFormatted",
                label: <Trans i18nKey="date" />,
              },
              {
                id: "customerName",
                label: <Trans i18nKey="channel" />,
                filter: (
                  <Search
                    name="customerName-search"
                    value={customerName}
                    onChange={setCustomerName}
                  />
                ),
              },
              {
                id: "endUserName",
                label: <Trans i18nKey="Client" />,
                filter: (
                  <Search
                    name="endUserName-search"
                    value={endUserName}
                    onChange={setEndUserName}
                  />
                ),
              },
              { id: "status", label: <Trans i18nKey="Status" />
                ,filter:(<Select
                  options={options}
                  id="select-usage"
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={onChangestatus}
                  onClear={onClearstatus}
                  value={statusfilter}
                />),
              },
              {
                id: "statusDateFormatted",
                label: <Trans i18nKey="statusdate" />,
              },
              {
                id: "compensationClientFormatted",
                label: <Trans i18nKey="balancereport.compclient" />,
              },
              // {
              //   id: "compensationChannelFormatted",
              //   label: <Trans i18nKey="compchannel" />,
              //   index: currentUser.idRole == 11 || currentUser.idRole == 12 ? 'hidden': 'visible'
              // },
              {
                id: "subRegion",
                label: <Trans i18nKey="Subregion" />,
                filter: (
                  <Search
                    name="region-search"
                    value={subRegion}
                    onChange={setSubRegion}
                  />
                ),
              },
              { id: "comments", label: <Trans i18nKey="comments" />,filter:(
                <Search
                    name="comments-search"
                    value={commentfilter}
                    onChange={setcommentfilter}
                  />
              ) },
            ]}
            data={pagedData}
            onColumnReorder={handleOnColumnReorder}
            onSort={handleSort}
            loading={isLoading}
            preferences={{
              defaultOrder: config.map((c) => c.id),
              order,
              sortBy: {
                id: orderBy,
                type: orderType,
              },
            }}
            pagination={{
              currentPage,
              onPageChange: handlePageChange,
              pageSize,
              totalItems: filteredData.length,
            }}
          ></Table>
          <div style={{ textAlign: 'left' }}>
            <Button
                            onClick={()=>{
                                setTimeout(() => {
                                const dataXlsx = filteredData.map((item) => { return item; });
                                const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                                const wb = XLSX.utils.book_new();
                                const date = moment(new Date()).format('YYYYMMDDHHmm');
                                const filename = 'Orders-' + date + '.xlsx';
                                const ws_name = "Orders";
                                XLSX.utils.book_append_sheet(wb, ws, ws_name);
                                XLSX.writeFile(wb, filename);
                                }, 750);
                            }}
                            disabled={filteredData.length === 0}
                            leadingIcon={<IconDownload />}
                            title={<Trans i18nKey="download data" />}
                        >
                            {<Trans i18nKey="download" />}
                        </Button>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(Orders);
